import axios from "axios";
import Cookies from "js-cookie";
import { TOKEN_COOKIE_NAME } from "../store/authSlice";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = Cookies.get(TOKEN_COOKIE_NAME);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getDevClock() {
  return client.get("/api/dev/clock").then((r) => r.data);
}

export function setDevClock(instant) {
  return client.post("/api/dev/clock", { instant }).then((r) => r.data);
}

export function advanceDevClock({ days, hours } = {}) {
  const body = {};
  if (days !== undefined) body.days = days;
  if (hours !== undefined) body.hours = hours;
  return client.post("/api/dev/clock/advance", body).then((r) => r.data);
}

export function resetDevClock() {
  return client.post("/api/dev/clock/reset").then((r) => r.data);
}

export function reseedDevClock() {
  return client.post("/api/dev/clock/reseed").then((r) => r.data);
}
